import { createFileRoute } from "@tanstack/react-router";
import { PropertyForm } from "@/components/admin/PropertyForm";

export const Route = createFileRoute("/_authenticated/admin/propiedades/nueva")({
  head: () => ({ meta: [{ title: "Nueva propiedad — Admin" }] }),
  component: () => <PropertyForm mode="new" />,
});
